module.exports = __webpack_public_path__ + "img/pageNone.e6c41aa8.png";